// DomainDetail.js — UPDATED
// Replaced the single "Domain Info" tab with three tabs matching the design:
//   Results     — verdict banner + findings list (from ResultsTab)
//   Parameters  — submitted enrollment details (from ParametersTab)
//   API Response — raw JSON dump of the full API response
//
// The old DomainInfoTab is no longer imported here; its monitoring controls
// (toggle switch and manual check) have been moved into ResultsTab.

import React, { useState, useEffect, useCallback } from "react";
import { PageHeader, Tabs, Button, Spin } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { API_DOMAIN_MONITOR } from "../../config/config";
import axios from "axios";
import Cookies from "js-cookie";
import CatchError from "../../helper/CatchError";
import ResultsTab from "./components/ResultsTab";
import ParametersTab from "./components/ParametersTab";
import { useHistory } from "react-router-dom";

const { TabPane } = Tabs;

const DomainDetail = (props) => {
    const history = useHistory();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { t = (key) => key } = props;
    const domainId = props.match.params.id;

    const getDomainDetail = useCallback(async () => {
        const api_url = API_DOMAIN_MONITOR + `/v1/domains/${domainId}/details`;
        setLoading(true);

        await axios
            .get(api_url, {
                headers: {
                    Authorization: "Bearer " + Cookies.get("dm_token"),
                }
            })
            .then(({ data }) => {
                // DM returns { success, data: {...} }
                setData(data && data.data ? data.data : data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                CatchError(error);
                setLoading(false);
            });
    }, [domainId]);

    useEffect(() => {
        getDomainDetail();
    }, [getDomainDetail]);

    return (
        <>
            <PageHeader
                title={t("domain_monitor.domain_details_title")}
                subTitle={`(${data?.domain_name || data?.domain || domainId})`}
                extra={[
                    <Button
                        key="back"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => history.push("/domains")}
                    >
                        {t("domain_monitor.back_to_list")}
                    </Button>
                ]}
            />
            {loading ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                    <Spin size="large" />
                </div>
            ) : (
                // Three tabs: Results, Parameters, API Response
                <Tabs type="card" defaultActiveKey="results" className="custom-tabs-card">
                    {/* Results — verdict + findings from API response */}
                    <TabPane tab={t("domain_monitor.tab_results")} key="results">
                        <ResultsTab
                            t={t}
                            data={data}
                            onRefresh={getDomainDetail}
                        />
                    </TabPane>

                    {/* Parameters — submitted enrollment details */}
                    <TabPane tab={t("domain_monitor.tab_parameters")} key="parameters">
                        <ParametersTab
                            t={t}
                            data={data}
                            onRefresh={getDomainDetail}
                        />
                    </TabPane>

                    {/* API Response — full raw JSON from the details endpoint */}
                    <TabPane tab={t("domain_monitor.tab_api_response")} key="api_response">
                        <pre style={{
                            background: "#f5f5f5",
                            padding: "16px",
                            borderRadius: "4px",
                            maxHeight: "600px",
                            overflow: "auto",
                            fontSize: "12px"
                        }}>
                            {JSON.stringify(data, null, 2)}
                        </pre>
                    </TabPane>
                </Tabs>
            )}
        </>
    );
};

export default DomainDetail;
